import gql from 'graphql-tag';

export default gql`
  mutation UpdateProgress(
    $_id: MongoID!
    $progress: Float
    $activetime: Float
    $watchedRanges: [[Float]]
    $lastWatched: Float
  ) {
    updateProgress(
      _id: $_id
      record: { progress: $progress, activetime: $activetime, watchedRanges: $watchedRanges, lastWatched: $lastWatched }
    ) {
      recordId
    }
  }
`;
